var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppDownloadOsGeneralWhite = function SvgAppDownloadOsGeneralWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M16.576 12.63h-9.57a.5.5 0 1 0 0 1h9.57l-3.466 3.465a.5.5 0 0 0 .707.707l4.243-4.242a.5.5 0 0 0-.002-.863l-4.24-4.24a.5.5 0 0 0-.708.707zm8.235.5c0 6.851-5.554 12.405-12.406 12.405C5.555 25.535 0 19.981 0 13.13S5.554.723 12.405.723c6.852 0 12.406 5.554 12.406 12.406"
  })));
};
export default SvgAppDownloadOsGeneralWhite;